export default __webpack_public_path__ + "static/planning-recommended-2024-e70d9762c40413bc2b097a4202ce78fc.png";